import React, { useState } from 'react';
import {
  Send, TrendingUp, CheckCircle, Clock, XCircle, RefreshCw,
  ChevronRight, FileText, Zap, CreditCard, Smartphone
} from 'lucide-react';
import './Envio.css';

// ── Mock data: Cobranças ──────────────────────────────────────────────────────
const mockCobrancas = [
  { id: 1, client: 'João Silva',     type: 'CPFL',  amount: 220, sentAt: '2026-03-19 08:32', status: 'entregue',  channel: 'WhatsApp' },
  { id: 2, client: 'Maria Santos',   type: 'Asaas', amount: 200, sentAt: '2026-03-19 08:35', status: 'pendente',  channel: 'SMS'      },
  { id: 3, client: 'Carlos Costa',   type: 'Pix',   amount: 180, sentAt: '2026-03-18 14:10', status: 'falhou',    channel: 'WhatsApp' },
  { id: 4, client: 'Ana Souza',      type: 'CPFL',  amount: 210, sentAt: '2026-03-18 09:00', status: 'entregue',  channel: 'E-mail'   },
  { id: 5, client: 'Pedro Lima',     type: 'Asaas', amount: 195, sentAt: '2026-03-17 11:20', status: 'entregue',  channel: 'WhatsApp' },
  { id: 6, client: 'Lucia Ferreira', type: 'Pix',   amount: 160, sentAt: '2026-03-17 10:05', status: 'pendente',  channel: 'SMS'      },
  { id: 7, client: 'Roberto Alves',  type: 'CPFL',  amount: 230, sentAt: '2026-03-16 16:45', status: 'falhou',    channel: 'E-mail'   },
  { id: 8, client: 'Fernanda Dias',  type: 'Asaas', amount: 185, sentAt: '2026-03-16 08:55', status: 'entregue',  channel: 'WhatsApp' },
];

// ── Mock data: Marketing ──────────────────────────────────────────────────────
const mockMarketing = [
  { id: 1, campanha: 'Promoção Março',        tipo: 'WhatsApp', enviados: 320, entregues: 298, lidos: 210, falhas: 22, sentAt: '2026-03-15 09:00', status: 'concluido' },
  { id: 2, campanha: 'Lembrete Vencimento',   tipo: 'SMS',      enviados: 180, entregues: 174, lidos: 0,   falhas: 6,  sentAt: '2026-03-17 10:30', status: 'concluido' },
  { id: 3, campanha: 'Novidades Abril',        tipo: 'E-mail',   enviados: 500, entregues: 480, lidos: 320, falhas: 20, sentAt: '2026-03-19 07:00', status: 'enviando'  },
  { id: 4, campanha: 'Black Friday Antecip.',  tipo: 'WhatsApp', enviados: 0,   entregues: 0,   lidos: 0,   falhas: 0,  sentAt: '—',                status: 'agendado'  },
];

// ── Mock data: Contratos ──────────────────────────────────────────────────────
const mockContratos = [
  { id: 1, client: 'Silvana Feitoza',  type: 'CPFL',  sentAt: '2026-03-19 09:10', status: 'aguardando', channel: 'WhatsApp', vendedor: 'Carlos Oliveira' },
  { id: 2, client: 'Maria Santos',     type: 'Asaas', sentAt: '2026-03-19 10:22', status: 'assinado',   channel: 'E-mail',   vendedor: 'Ana Lima'        },
  { id: 3, client: 'Roberto Ferreira', type: 'Pix',   sentAt: '2026-03-18 14:05', status: 'expirado',   channel: 'WhatsApp', vendedor: 'Carlos Oliveira' },
  { id: 4, client: 'Fernanda Lima',    type: 'CPFL',  sentAt: '2026-03-18 16:30', status: 'assinado',   channel: 'SMS',      vendedor: 'Ana Lima'        },
  { id: 5, client: 'Pedro Alves',      type: 'Asaas', sentAt: '2026-03-17 11:00', status: 'aguardando', channel: 'WhatsApp', vendedor: 'Carlos Oliveira' },
  { id: 6, client: 'Lucia Mendes',     type: 'Pix',   sentAt: '2026-03-17 08:45', status: 'recusado',   channel: 'E-mail',   vendedor: 'Ana Lima'        },
];

// ── Mock data: Cancelamentos ──────────────────────────────────────────────────
const mockCancelamentos = [
  { id: 1, client: 'João Costa',     type: 'CPFL',  sentAt: '2026-03-19 08:00', status: 'aguardando', channel: 'WhatsApp', motivo: 'Solicitação do cliente'      },
  { id: 2, client: 'Ana Rodrigues',  type: 'Asaas', sentAt: '2026-03-18 13:20', status: 'assinado',   channel: 'E-mail',   motivo: 'Inadimplência'               },
  { id: 3, client: 'Marcos Pereira', type: 'Pix',   sentAt: '2026-03-18 09:55', status: 'expirado',   channel: 'SMS',      motivo: 'Mudança de endereço'         },
  { id: 4, client: 'Carla Nunes',    type: 'CPFL',  sentAt: '2026-03-17 15:40', status: 'recusado',   channel: 'WhatsApp', motivo: 'Cliente desistiu do cancel.' },
  { id: 5, client: 'Bruno Teixeira', type: 'Asaas', sentAt: '2026-03-16 10:10', status: 'assinado',   channel: 'E-mail',   motivo: 'Fim de contrato'             },
];

// ── Config de status ──────────────────────────────────────────────────────────
const statusConfig = {
  entregue:   { label: 'Entregue',    color: 'green',  Icon: CheckCircle },
  pendente:   { label: 'Pendente',    color: 'amber',  Icon: Clock       },
  falhou:     { label: 'Falhou',      color: 'red',    Icon: XCircle     },
  concluido:  { label: 'Concluído',   color: 'green',  Icon: CheckCircle },
  enviando:   { label: 'Enviando',    color: 'blue',   Icon: RefreshCw   },
  agendado:   { label: 'Agendado',    color: 'purple', Icon: Clock       },
  aguardando: { label: 'Aguardando',  color: 'amber',  Icon: Clock       },
  assinado:   { label: 'Assinado ✓',  color: 'green',  Icon: CheckCircle },
  expirado:   { label: 'Expirado',    color: 'gray',   Icon: XCircle     },
  recusado:   { label: 'Recusado',    color: 'red',    Icon: XCircle     },
};

// ── TypeBadge (igual ao Pagamentos) ──────────────────────────────────────────
const TypeBadge = ({ type }) => {
  const config = {
    CPFL:  { Icon: Zap,        cls: 'type-cpfl'  },
    Asaas: { Icon: CreditCard, cls: 'type-asaas' },
    Pix:   { Icon: Smartphone, cls: 'type-pix'   },
  };
  const { Icon, cls } = config[type] || {};
  return (
    <span className={`type-badge ${cls}`}>
      {Icon && <Icon size={13} />}
      {type}
    </span>
  );
};

// ── Componente de badge de status ─────────────────────────────────────────────
function StatusBadge({ status }) {
  const cfg = statusConfig[status] || { label: status, color: 'gray', Icon: Clock };
  return (
    <span className={`envio-badge badge-${cfg.color}`}>
      <cfg.Icon size={11} />
      {cfg.label}
    </span>
  );
}

// ── Painel: Status Envio de Cobrança ─────────────────────────────────────────
function StatusCobranca() {
  const [filter, setFilter] = useState('todos');
  const [search, setSearch] = useState('');

  const filtered = mockCobrancas.filter((c) => {
    const matchStatus = filter === 'todos' || c.status === filter;
    const matchSearch = c.client.toLowerCase().includes(search.toLowerCase());
    return matchStatus && matchSearch;
  });

  const total     = mockCobrancas.length;
  const entregues = mockCobrancas.filter((c) => c.status === 'entregue').length;
  const pendentes = mockCobrancas.filter((c) => c.status === 'pendente').length;
  const falhas    = mockCobrancas.filter((c) => c.status === 'falhou').length;
  const taxa      = Math.round((entregues / total) * 100);

  return (
    <div className="envio-panel">
      <div className="envio-summary-grid">
        <div className="envio-summary-card green">
          <CheckCircle size={20} />
          <div>
            <div className="envio-summary-label">Entregues</div>
            <div className="envio-summary-value">{entregues}</div>
          </div>
        </div>
        <div className="envio-summary-card amber">
          <Clock size={20} />
          <div>
            <div className="envio-summary-label">Pendentes</div>
            <div className="envio-summary-value">{pendentes}</div>
          </div>
        </div>
        <div className="envio-summary-card red">
          <XCircle size={20} />
          <div>
            <div className="envio-summary-label">Falhas</div>
            <div className="envio-summary-value">{falhas}</div>
          </div>
        </div>
        <div className="envio-summary-card blue">
          <TrendingUp size={20} />
          <div>
            <div className="envio-summary-label">Taxa de Entrega</div>
            <div className="envio-summary-value">{taxa}%</div>
          </div>
        </div>
      </div>

      <div className="envio-filters">
        <div className="envio-filter-tabs">
          {['todos', 'entregue', 'pendente', 'falhou'].map((f) => (
            <button
              key={f}
              className={`envio-tab ${filter === f ? 'active' : ''}`}
              onClick={() => setFilter(f)}
            >
              {f === 'todos' ? 'Todos' : statusConfig[f]?.label}
            </button>
          ))}
        </div>
        <div className="envio-search">
          <input
            type="text"
            placeholder="Buscar cliente..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      <div className="envio-table-wrapper">
        <table className="envio-table">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Modalidade</th>
              <th>Valor</th>
              <th>Canal</th>
              <th>Enviado em</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((c, i) => (
              <tr key={c.id} className={i % 2 === 0 ? 'row-even' : 'row-odd'}>
                <td className="td-client">
                  <div className="envio-client-cell">
                    <div className="envio-mini-avatar">{c.client.charAt(0)}</div>
                    {c.client}
                  </div>
                </td>
                <td><TypeBadge type={c.type} /></td>
                <td className="td-amount">R$ {c.amount}</td>
                <td className="td-channel">{c.channel}</td>
                <td className="td-date">{c.sentAt}</td>
                <td><StatusBadge status={c.status} /></td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={6} className="empty-row">Nenhum resultado encontrado</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ── Painel: Status Envio Marketing ───────────────────────────────────────────
function StatusMarketing() {
  const [filter, setFilter] = useState('todos');

  const filtered = mockMarketing.filter((c) =>
    filter === 'todos' || c.status === filter
  );

  const totalEnviados  = mockMarketing.reduce((s, m) => s + m.enviados, 0);
  const totalEntregues = mockMarketing.reduce((s, m) => s + m.entregues, 0);
  const totalLidos     = mockMarketing.reduce((s, m) => s + m.lidos, 0);
  const totalFalhas    = mockMarketing.reduce((s, m) => s + m.falhas, 0);

  return (
    <div className="envio-panel">
      <div className="envio-summary-grid">
        <div className="envio-summary-card blue">
          <Send size={20} />
          <div>
            <div className="envio-summary-label">Total Enviados</div>
            <div className="envio-summary-value">{totalEnviados.toLocaleString('pt-BR')}</div>
          </div>
        </div>
        <div className="envio-summary-card green">
          <CheckCircle size={20} />
          <div>
            <div className="envio-summary-label">Entregues</div>
            <div className="envio-summary-value">{totalEntregues.toLocaleString('pt-BR')}</div>
          </div>
        </div>
        <div className="envio-summary-card purple">
          <TrendingUp size={20} />
          <div>
            <div className="envio-summary-label">Lidos</div>
            <div className="envio-summary-value">{totalLidos.toLocaleString('pt-BR')}</div>
          </div>
        </div>
        <div className="envio-summary-card red">
          <XCircle size={20} />
          <div>
            <div className="envio-summary-label">Falhas</div>
            <div className="envio-summary-value">{totalFalhas}</div>
          </div>
        </div>
      </div>

      <div className="envio-filters">
        <div className="envio-filter-tabs">
          {['todos', 'concluido', 'enviando', 'agendado'].map((f) => (
            <button
              key={f}
              className={`envio-tab ${filter === f ? 'active' : ''}`}
              onClick={() => setFilter(f)}
            >
              {f === 'todos' ? 'Todos' : statusConfig[f]?.label}
            </button>
          ))}
        </div>
      </div>

      <div className="mkt-campaign-list">
        {filtered.map((m) => {
          const pctEntrega = m.enviados > 0 ? Math.round((m.entregues / m.enviados) * 100) : 0;
          const pctLeitura = m.entregues > 0 ? Math.round((m.lidos / m.entregues) * 100) : 0;
          return (
            <div key={m.id} className="mkt-campaign-card">
              <div className="mkt-campaign-top">
                <div>
                  <div className="mkt-campaign-name">{m.campanha}</div>
                  <div className="mkt-campaign-meta">
                    <span className="mkt-tipo-badge">{m.tipo}</span>
                    <span className="mkt-sent-at">🕐 {m.sentAt}</span>
                  </div>
                </div>
                <StatusBadge status={m.status} />
              </div>

              {m.enviados > 0 && (
                <div className="mkt-progress-section">
                  <div className="mkt-progress-row">
                    <span>Entrega</span>
                    <div className="mkt-bar-wrapper">
                      <div className="mkt-bar">
                        <div className="mkt-bar-fill green" style={{ width: `${pctEntrega}%` }} />
                      </div>
                    </div>
                    <span className="mkt-pct">{pctEntrega}%</span>
                  </div>
                  {m.lidos > 0 && (
                    <div className="mkt-progress-row">
                      <span>Leitura</span>
                      <div className="mkt-bar-wrapper">
                        <div className="mkt-bar">
                          <div className="mkt-bar-fill purple" style={{ width: `${pctLeitura}%` }} />
                        </div>
                      </div>
                      <span className="mkt-pct">{pctLeitura}%</span>
                    </div>
                  )}
                </div>
              )}

              <div className="mkt-numbers">
                <div className="mkt-num-item blue">
                  <div className="mkt-num">{m.enviados}</div>
                  <div className="mkt-num-label">Enviados</div>
                </div>
                <div className="mkt-num-item green">
                  <div className="mkt-num">{m.entregues}</div>
                  <div className="mkt-num-label">Entregues</div>
                </div>
                <div className="mkt-num-item purple">
                  <div className="mkt-num">{m.lidos}</div>
                  <div className="mkt-num-label">Lidos</div>
                </div>
                <div className="mkt-num-item red">
                  <div className="mkt-num">{m.falhas}</div>
                  <div className="mkt-num-label">Falhas</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── Painel: Status Envio de Contratos ────────────────────────────────────────
function StatusContratos() {
  const [filter, setFilter] = useState('todos');
  const [search, setSearch] = useState('');

  const filtered = mockContratos.filter((c) => {
    const matchStatus = filter === 'todos' || c.status === filter;
    const matchSearch = c.client.toLowerCase().includes(search.toLowerCase());
    return matchStatus && matchSearch;
  });

  const total      = mockContratos.length;
  const assinados  = mockContratos.filter((c) => c.status === 'assinado').length;
  const aguardando = mockContratos.filter((c) => c.status === 'aguardando').length;
  const expirados  = mockContratos.filter((c) => c.status === 'expirado').length;
  const recusados  = mockContratos.filter((c) => c.status === 'recusado').length;
  const taxa       = total > 0 ? Math.round((assinados / total) * 100) : 0;

  return (
    <div className="envio-panel">
      <div className="envio-summary-grid">
        <div className="envio-summary-card green">
          <CheckCircle size={20} />
          <div>
            <div className="envio-summary-label">Assinados</div>
            <div className="envio-summary-value">{assinados}</div>
          </div>
        </div>
        <div className="envio-summary-card amber">
          <Clock size={20} />
          <div>
            <div className="envio-summary-label">Aguardando</div>
            <div className="envio-summary-value">{aguardando}</div>
          </div>
        </div>
        <div className="envio-summary-card red">
          <XCircle size={20} />
          <div>
            <div className="envio-summary-label">Recusados</div>
            <div className="envio-summary-value">{recusados}</div>
          </div>
        </div>
        <div className="envio-summary-card blue">
          <TrendingUp size={20} />
          <div>
            <div className="envio-summary-label">Taxa de Assinatura</div>
            <div className="envio-summary-value">{taxa}%</div>
          </div>
        </div>
      </div>

      <div className="envio-filters">
        <div className="envio-filter-tabs">
          {['todos', 'aguardando', 'assinado', 'expirado', 'recusado'].map((f) => (
            <button
              key={f}
              className={`envio-tab ${filter === f ? 'active' : ''}`}
              onClick={() => setFilter(f)}
            >
              {f === 'todos' ? 'Todos' : statusConfig[f]?.label}
            </button>
          ))}
        </div>
        <div className="envio-search">
          <input
            type="text"
            placeholder="Buscar cliente..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      <div className="envio-table-wrapper">
        <table className="envio-table">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Modalidade</th>
              <th>Vendedor</th>
              <th>Canal</th>
              <th>Enviado em</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((c, i) => (
              <tr key={c.id} className={i % 2 === 0 ? 'row-even' : 'row-odd'}>
                <td className="td-client">
                  <div className="envio-client-cell">
                    <div className="envio-mini-avatar">{c.client.charAt(0)}</div>
                    {c.client}
                  </div>
                </td>
                <td><TypeBadge type={c.type} /></td>
                <td className="td-channel">{c.vendedor}</td>
                <td className="td-channel">{c.channel}</td>
                <td className="td-date">{c.sentAt}</td>
                <td><StatusBadge status={c.status} /></td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={6} className="empty-row">Nenhum resultado encontrado</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ── Painel: Status Envio Termo de Cancelamento ───────────────────────────────
function StatusCancelamentos() {
  const [filter, setFilter] = useState('todos');
  const [search, setSearch] = useState('');

  const filtered = mockCancelamentos.filter((c) => {
    const matchStatus = filter === 'todos' || c.status === filter;
    const matchSearch = c.client.toLowerCase().includes(search.toLowerCase());
    return matchStatus && matchSearch;
  });

  const assinados  = mockCancelamentos.filter((c) => c.status === 'assinado').length;
  const aguardando = mockCancelamentos.filter((c) => c.status === 'aguardando').length;
  const expirados  = mockCancelamentos.filter((c) => c.status === 'expirado').length;
  const recusados  = mockCancelamentos.filter((c) => c.status === 'recusado').length;

  return (
    <div className="envio-panel">
      <div className="envio-summary-grid">
        <div className="envio-summary-card green">
          <CheckCircle size={20} />
          <div>
            <div className="envio-summary-label">Assinados</div>
            <div className="envio-summary-value">{assinados}</div>
          </div>
        </div>
        <div className="envio-summary-card amber">
          <Clock size={20} />
          <div>
            <div className="envio-summary-label">Aguardando</div>
            <div className="envio-summary-value">{aguardando}</div>
          </div>
        </div>
        <div className="envio-summary-card gray">
          <XCircle size={20} />
          <div>
            <div className="envio-summary-label">Expirados</div>
            <div className="envio-summary-value">{expirados}</div>
          </div>
        </div>
        <div className="envio-summary-card red">
          <XCircle size={20} />
          <div>
            <div className="envio-summary-label">Recusados</div>
            <div className="envio-summary-value">{recusados}</div>
          </div>
        </div>
      </div>

      <div className="envio-filters">
        <div className="envio-filter-tabs">
          {['todos', 'aguardando', 'assinado', 'expirado', 'recusado'].map((f) => (
            <button
              key={f}
              className={`envio-tab ${filter === f ? 'active' : ''}`}
              onClick={() => setFilter(f)}
            >
              {f === 'todos' ? 'Todos' : statusConfig[f]?.label}
            </button>
          ))}
        </div>
        <div className="envio-search">
          <input
            type="text"
            placeholder="Buscar cliente..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      <div className="envio-table-wrapper">
        <table className="envio-table">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Modalidade</th>
              <th>Motivo</th>
              <th>Canal</th>
              <th>Enviado em</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((c, i) => (
              <tr key={c.id} className={i % 2 === 0 ? 'row-even' : 'row-odd'}>
                <td className="td-client">
                  <div className="envio-client-cell">
                    <div className="envio-mini-avatar">{c.client.charAt(0)}</div>
                    {c.client}
                  </div>
                </td>
                <td><TypeBadge type={c.type} /></td>
                <td className="td-channel">{c.motivo}</td>
                <td className="td-channel">{c.channel}</td>
                <td className="td-date">{c.sentAt}</td>
                <td><StatusBadge status={c.status} /></td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={6} className="empty-row">Nenhum resultado encontrado</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ── Componente principal ──────────────────────────────────────────────────────
export default function Envio() {
  const [activeTab, setActiveTab] = useState(null);

  const options = [
    {
      id: 'cobranca',
      label: 'Status Envio de Cobrança',
      desc: 'Acompanhe o status das cobranças enviadas aos clientes',
      icon: Send,
      color: 'blue',
    },
    {
      id: 'marketing',
      label: 'Status Envio Marketing',
      desc: 'Acompanhe o desempenho das campanhas de marketing enviadas',
      icon: TrendingUp,
      color: 'purple',
    },
    {
      id: 'contratos',
      label: 'Status Envio de Contratos',
      desc: 'Monitore contratos enviados e aguardando assinatura digital',
      icon: FileText,
      color: 'green',
    },
    {
      id: 'cancelamentos',
      label: 'Status Envio Termo de Cancelamento',
      desc: 'Acompanhe os termos de cancelamento enviados aos clientes',
      icon: XCircle,
      color: 'red',
    },
  ];

  return (
    <div className="envio-page">
      <div className="envio-page-header">
        <h1>Envio</h1>
        <p className="envio-page-subtitle">Acompanhe o status dos seus envios de cobrança e marketing</p>
      </div>

      <div className="envio-option-grid">
        {options.map((opt) => (
          <button
            key={opt.id}
            className={`envio-option-card color-${opt.color} ${activeTab === opt.id ? 'active' : ''}`}
            onClick={() => setActiveTab(activeTab === opt.id ? null : opt.id)}
          >
            <div className={`envio-option-icon color-${opt.color}`}>
              <opt.icon size={26} />
            </div>
            <div className="envio-option-text">
              <div className="envio-option-label">{opt.label}</div>
              <div className="envio-option-desc">{opt.desc}</div>
            </div>
            <ChevronRight
              size={20}
              className={`envio-option-arrow ${activeTab === opt.id ? 'rotated' : ''}`}
            />
          </button>
        ))}
      </div>

      {activeTab === 'cobranca'      && <StatusCobranca      />}
      {activeTab === 'marketing'     && <StatusMarketing     />}
      {activeTab === 'contratos'     && <StatusContratos     />}
      {activeTab === 'cancelamentos' && <StatusCancelamentos />}
    </div>
  );
}
